import * as types from './mutation-types';

export const closeAll = async ({ commit }) => { commit(types.CLOSE_ALL) };

export default {
    closeAll,
};



// WEBPACK FOOTER //
// ./src/store/modules/menu/actions.js